import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId1178: SiteIdOverrideConfig = {
  car: {
    iHaveDiscount: "wizard.car.having.brand.title",
  },
};
